import { formatPatientName } from './formatPatientName';

const PATIENT_COLORS = [
  { bg: '#E3F2FD', border: '#2196F3', text: '#0D47A1' },
  { bg: '#F3E5F5', border: '#9C27B0', text: '#4A148C' },
  { bg: '#E8F5E9', border: '#4CAF50', text: '#1B5E20' },
  { bg: '#FFF3E0', border: '#FF9800', text: '#E65100' },
  { bg: '#FCE4EC', border: '#E91E63', text: '#880E4F' },
];


export const PatientContextManager = {
  assignColors(patients) {
    return patients.map((patient, index) => ({
      ...patient,
      colorIndex: index % PATIENT_COLORS.length,
      colors: PATIENT_COLORS[index % PATIENT_COLORS.length],
    }));
  },

  getPatientColor(colorIndex) {
    return PATIENT_COLORS[colorIndex % PATIENT_COLORS.length];
  },

  formatPatientLabel(patient) {
    // ``relationship_type`` describes the VIEWER's role toward the subject
    // (e.g. Lisa is the "parent" of Taylor). The selector labels the SUBJECT,
    // so render the subject's role relative to the viewer — a parent's chart
    // subject is their "Child", not "Parent".
    const rt = (patient.relationship_type || '').toLowerCase();
    let subjectRole;
    if (!rt || rt === 'self' || rt === 'primary') {
      subjectRole = 'Self';
    } else if (rt === 'parent' || rt === 'guardian') {
      subjectRole = 'Child';
    } else if (rt === 'partner' || rt === 'spouse') {
      subjectRole = 'Partner';
    } else {
      subjectRole = rt.charAt(0).toUpperCase() + rt.slice(1);
    }
    const name = formatPatientName(patient);
    return `${name} (${subjectRole})`;
  },
};

export default PatientContextManager;
